import React from 'react';
import { DefaultContainer, AnimationContainer } from './Icons-styled';

interface AdvancedIconProps {
  selected?: boolean;
}

const AdvancedIcon: React.FC<AdvancedIconProps> = ({ selected = false }) => {
  const svg = (
    <svg
      style={{
        fill: selected ? '#48e2cb' : '#cacaca',
        maxHeight: '64px',
        maxWidth: '64px'
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <path d="M47.082 28.355l-6.956-4.175 6.956-4.174a.716.716 0 0 0 0-1.35L24.877 5.33a2.219 2.219 0 0 0-1.805 0L.87 18.655a.718.718 0 0 0 0 1.351l6.95 4.171-6.95 4.175a.718.718 0 0 0 0 1.352l22.204 13.324a2.125 2.125 0 0 0 1.805 0l22.204-13.324a.714.714 0 0 0 0-1.349zM23.485 6.015a1.104 1.104 0 0 1 .49-.086 1.115 1.115 0 0 1 .49.086l22.188 13.316-22.188 13.315a1.102 1.102 0 0 1-.49.086 1.114 1.114 0 0 1-.489-.086L1.296 19.331zm.98 36.328a1.101 1.101 0 0 1-.49.086 1.114 1.114 0 0 1-.489-.086L1.296 29.028l7.3-4.384 14.477 8.687a2.125 2.125 0 0 0 1.805 0l14.471-8.684 7.302 4.382z"></path>
    </svg>
  );
  return selected ? (
    <AnimationContainer>{svg}</AnimationContainer>
  ) : (
    <DefaultContainer>{svg}</DefaultContainer>
  );
};

export default AdvancedIcon;
